<template>
  <!-- bootstrap-vue 2.23 b-collapse: `.collapse(.show)` + v-show, açılıp kapanırken `.collapsing` ve
       yükseklik geçişi (BVCollapse ile aynı sınıf ve kancalar). Durum/akordeon utils/collapse.js'te. -->
  <transition enter-from-class="" enter-active-class="collapsing" enter-to-class="collapse show"
              leave-from-class="collapse show" leave-active-class="collapsing" leave-to-class="collapse"
              @enter="onEnter" @after-enter="onAfterEnter" @leave="onLeave" @after-leave="onAfterLeave">
    <component :is="tag" v-show="show" :id="id" :class="classObject" @click="clickHandler"><slot :visible="show" :close="close" /></component>
  </transition>
</template>

<script>
  import { registerCollapse, unregisterCollapse, openedInAccordion, emitCollapseState } from '../../utils/collapse';

  const reflow = el => el && el.offsetHeight;

  export default {
    name: 'BaseCollapse',
    emits: ['input', 'show', 'shown', 'hide', 'hidden'],
    props: {
      id: { type: String, default: null },
      tag: { type: String, default: 'div' },
      visible: { type: Boolean, default: false },
      accordion: { type: String, default: null },
      isNav: { type: Boolean, default: false }
    },
    data() {
      return {
        show: this.visible,
        transitioning: false
      };
    },
    computed: {
      classObject() {
        return {
          'navbar-collapse': this.isNav,
          collapse: !this.transitioning,
          show: this.show && !this.transitioning
        };
      }
    },
    watch: {
      visible(value) {
        if (value !== this.show) this.show = value;
      },
      show(value, oldValue) {
        if (value !== oldValue) this.emitState();
      }
    },
    mounted() {
      this.show = this.visible;
      registerCollapse(this.id, this);
      if (this.isNav) {
        window.addEventListener('resize', this.handleResize);
        window.addEventListener('orientationchange', this.handleResize);
        this.handleResize();
      }
      this.$nextTick(() => this.emitState());
    },
    updated() {
      emitCollapseState(this.id, this.show);
    },
    beforeUnmount() {
      this.show = false;
      unregisterCollapse(this.id, this);
      if (this.isNav) {
        window.removeEventListener('resize', this.handleResize);
        window.removeEventListener('orientationchange', this.handleResize);
      }
    },
    methods: {
      toggle() {
        this.show = !this.show;
      },
      close() {
        this.show = false;
      },
      emitState() {
        this.$emit('input', this.show);
        emitCollapseState(this.id, this.show);
        if (this.accordion && this.show) openedInAccordion(this.id, this.accordion);
      },
      onEnter(el) {
        this.transitioning = true;
        this.$emit('show');
        el.style.height = '0';
        window.requestAnimationFrame(() => {
          reflow(el);
          el.style.height = `${el.scrollHeight}px`;
        });
      },
      onAfterEnter(el) {
        this.transitioning = false;
        el.style.removeProperty('height');
        this.$emit('shown');
      },
      onLeave(el) {
        this.transitioning = true;
        this.$emit('hide');
        el.style.height = 'auto';
        el.style.display = 'block';
        el.style.height = `${el.getBoundingClientRect().height}px`;
        reflow(el);
        el.style.height = '0';
      },
      onAfterLeave(el) {
        this.transitioning = false;
        el.style.removeProperty('height');
        this.$emit('hidden');
      },
      /* Mobil navbar: menüdeki bir bağlantıya tıklanınca daraltılmış menü kapanır. */
      clickHandler(event) {
        const el = event.target;
        if (!this.isNav || !el || window.getComputedStyle(this.$el).display !== 'block') return;
        if (el.closest && el.closest('.nav-link,.dropdown-item') && !this.checkDisplayBlock()) this.show = false;
      },
      checkDisplayBlock() {
        const restore = this.$el.classList.contains('show');
        this.$el.classList.remove('show');
        const isBlock = window.getComputedStyle(this.$el).display === 'block';
        if (restore) this.$el.classList.add('show');
        return isBlock;
      },
      handleResize() {
        this.show = window.getComputedStyle(this.$el).display === 'block';
      }
    }
  };
</script>
